<div class="hidden-md hidden-lg">
  <app-nav></app-nav>
</div>
<div class="visible-lg visible-md">
  <app-headermain></app-headermain>
</div>

<div class="suc-page">
  <div style="max-width: 620px; margin: 0 auto;">

    <!-- ── Hero: success checkmark ── -->
    <div class="suc-hero">
      <div class="suc-check-circle">
        <svg class="suc-check-svg" viewBox="0 0 42 42">
          <polyline class="suc-check-path" points="8,22 17,31 34,12"/>
        </svg>
      </div>
      <h2 style="margin: 0 0 6px; font-size: 24px; font-weight: 800;">Booking Confirmed!</h2>
      <p style="margin: 0 0 12px; opacity: 0.85; font-size: 14px;">
        Your payment was received and your seat is reserved.
      </p>
      <div class="suc-ref-badge">
        {{ bookingData?.data?.internal_booking_reference || bookingData?.payee?.booking_reference || bookingData?.internal_booking_reference }}
      </div>
      <p style="margin: 10px 0 0; font-size: 12px; opacity: 0.6;">Booking Reference</p>
    </div>

    <!-- ── Card body ── -->
    <div class="suc-card">

      <!-- Flight details -->
      <div class="suc-section">
        <div class="suc-section-title">
          <i class="fa fa-plane"></i> Flight Details
        </div>

        <!-- Route -->
        <div class="suc-route">
          <span class="suc-iata">{{ bookingData?.booking_data?.slices?.[0]?.origin?.iata_code }}</span>
          <div class="suc-arrow">
            <div class="suc-arrow-line"></div>
            <i class="fa fa-plane suc-arrow-icon"></i>
            <div class="suc-arrow-line"></div>
          </div>
          <span class="suc-iata">{{ bookingData?.booking_data?.slices?.[0]?.destination?.iata_code }}</span>
        </div>

        <!-- Airline logo + name -->
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 16px;">
          <img [src]="carrierLogoService.getCarrierLogo(bookingData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier)"
            style="width: 36px; height: 36px; object-fit: contain; border-radius: 6px; border: 1px solid #eee; padding: 3px;"
            (error)="carrierLogoService.setLogoPlaceholder($event)">
            <div>
              <div style="font-weight: 600; font-size: 14px; color: #111;">
                {{ bookingData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier?.name }}
              </div>
              <div style="font-size: 12px; color: #888;">
                {{ bookingData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier?.flight_number }}
                {{ bookingData?.booking_data?.slices?.[0]?.segments?.[0]?.marketing_carrier?.iata_code }}
              </div>
            </div>
          </div>

          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-map-marker-alt" style="margin-right:5px;"></i>From</span>
            <span class="suc-info-value">{{ bookingData?.booking_data?.slices?.[0]?.origin?.city_name }} ({{ bookingData?.booking_data?.slices?.[0]?.origin?.iata_code }})</span>
          </div>
          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-map-marker-alt" style="margin-right:5px; color:#CF2264;"></i>To</span>
            <span class="suc-info-value">{{ bookingData?.booking_data?.slices?.[0]?.destination?.city_name }} ({{ bookingData?.booking_data?.slices?.[0]?.destination?.iata_code }})</span>
          </div>
          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-calendar" style="margin-right:5px;"></i>Departure</span>
            <span class="suc-info-value">{{ bookingData?.booking_data?.slices?.[0]?.departing_day?.split('T')[0] }}</span>
          </div>
          @if (bookingData?.booking_data?.slices?.length > 1) {
            <div class="suc-info-row">
              <span class="suc-info-label"><i class="fa fa-calendar-check" style="margin-right:5px;"></i>Return</span>
              <span class="suc-info-value">{{ bookingData?.booking_data?.slices?.[1]?.departing_day?.split('T')[0] }}</span>
            </div>
          }
          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-chair" style="margin-right:5px;"></i>Class</span>
            <span class="suc-info-value">Economy</span>
          </div>
          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-stop-circle" style="margin-right:5px;"></i>Stops</span>
            <span class="suc-info-value">{{ bookingData?.booking_data?.slices?.[0]?.stops }}</span>
          </div>
        </div>

        <!-- Passenger details -->
        <div class="suc-section">
          <div class="suc-section-title">
            <i class="fa fa-users"></i> Passenger Details
          </div>

          @for (pax of bookingData?.passengers; track pax; let i = $index) {
            <div class="suc-pax-card">
              <span class="suc-pax-type-badge"
                [ngClass]="{'badge-adult': pax.type==='adult', 'badge-child': pax.type==='child', 'badge-infant': pax.type==='infant'}">
                {{ pax.type }}
              </span>
              <div style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 6px;">
                <div>
                  <div style="font-weight: 700; font-size: 15px; color: #111;">
                    {{ pax.given_name }} {{ pax.family_name }}
                  </div>
                  <div style="font-size: 12px; color: #888; margin-top: 3px;">
                    @if (pax.born_on) {
                      <span><i class="fa fa-birthday-cake" style="margin-right:4px;"></i>{{ pax.born_on }}</span>
                    }
                  </div>
                </div>
                <div style="text-align: right; font-size: 13px; color: #555;">
                  @if (pax.id_or_passport) {
                    <div><i class="fa fa-id-card" style="margin-right:4px;"></i>{{ pax.id_or_passport }}</div>
                  }
                  @if (pax.nationality) {
                    <div style="margin-top:3px;"><i class="fa fa-globe" style="margin-right:4px;"></i>{{ pax.nationality }}</div>
                  }
                </div>
              </div>
            </div>
          }

          <!-- Fallback if passengers not in data -->
          @if (!bookingData?.passengers?.length) {
            <p style="color:#888; font-size:14px; margin:0;">
              {{ bookingData?.booking_data?.passengers?.length }} Passenger(s) booked.
            </p>
          }
        </div>

        <!-- Fare breakdown -->
        <div class="suc-section">
          <div class="suc-section-title">
            <i class="fa fa-receipt"></i> Fare Breakdown
          </div>

          <div class="suc-fare-row">
            <span style="color:#888;">Base Fare</span>
            <span style="color:#111; font-weight:600;">
              {{ bookingData?.booking_data?.total_currency }} {{ bookingData?.booking_data?.total_amount | number:'1.0-0' }}
            </span>
          </div>

          @if (bookingData?.promo_discount) {
            <div class="suc-discount-row">
              <span><i class="fa fa-tag" style="margin-right:5px;"></i>Promo ({{ bookingData.promo_discount.code }})</span>
              <span>- {{ bookingData.promo_discount.user.currency }} {{ bookingData.promo_discount.user.amount | number:'1.0-0' }}</span>
            </div>
          }

          <div class="suc-fare-total">
            <span>Total Charged</span>
            @if (!bookingData?.promo_discount) {
              <span style="color:#1a7a3c;">
                {{ bookingData?.booking_data?.total_currency }} {{ bookingData?.booking_data?.total_amount | number:'1.0-0' }}
              </span>
            }
            @if (bookingData?.promo_discount) {
              <span style="color:#1a7a3c;">
                {{ bookingData.booking_data.total_currency }}
                {{ (bookingData.booking_data.total_amount - bookingData.promo_discount.user.amount) | number:'1.0-0' }}
              </span>
            }
          </div>

          <div style="margin-top: 14px;" class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-credit-card" style="margin-right:5px;"></i>Payment Method</span>
            <span class="suc-info-value" style="text-transform: capitalize;">{{ bookingData?.payee?.payments }}</span>
          </div>
          <div class="suc-info-row">
            <span class="suc-info-label"><i class="fa fa-envelope" style="margin-right:5px;"></i>Confirmation Email</span>
            <span class="suc-info-value">{{ bookingData?.payee?.customer?.email }}</span>
          </div>
        </div>

        <!-- What's next -->
        <div class="suc-section">
          <div class="suc-section-title">
            <i class="fa fa-list-check"></i> What Happens Next
          </div>

          <div class="suc-step">
            <div class="suc-step-icon"><i class="fa fa-envelope"></i></div>
            <div class="suc-step-text">
              <strong>Check your email</strong> — A booking confirmation and e-ticket will be sent to
              <strong>{{ bookingData?.payee?.customer?.email }}</strong> shortly.
            </div>
          </div>
          <div class="suc-step">
            <div class="suc-step-icon"><i class="fa fa-mobile-alt"></i></div>
            <div class="suc-step-text">
              <strong>Save your reference</strong> — Use booking reference
              <strong style="font-family:monospace;">{{ bookingData?.data?.internal_booking_reference || bookingData?.payee?.booking_reference }}</strong>
              for check-in or queries.
            </div>
          </div>
          <div class="suc-step">
            <div class="suc-step-icon"><i class="fa fa-headset"></i></div>
            <div class="suc-step-text">
              <strong>Need help?</strong> — Contact us at
              <strong>help&#64;buupass.com</strong> or call <strong>0715 763 362</strong>.
            </div>
          </div>
        </div>

        <!-- CTA -->
        <div class="suc-cta">
          <a routerLink="/" class="suc-btn-secondary">Back to Home</a>

        </div>

      </div>
    </div>
  </div>

  <app-footer></app-footer>
